class BtsPersonalization extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    this.field = this.querySelector('textarea');
    this.form = this.closest('form');
    this.paid = JSON.parse(this.querySelector('[data-personalized-variants]')?.textContent || '[]');
    this.sync(this.form?.querySelector('[name="id"]')?.value);
    document.addEventListener('variant:update', event => {
      if (String(event.detail?.data?.productId) === this.dataset.productId) this.sync(event.detail?.resource?.id);
    }, {signal:this.controller.signal});
    this.form?.addEventListener('submit', event => {
      this.sync(this.form.querySelector('[name="id"]')?.value);
      if (!this.form.reportValidity()) { event.preventDefault(); event.stopImmediatePropagation(); }
    }, {capture:true,signal:this.controller.signal});
  }
  sync(id) {
    if (!this.field || this.dataset.mode !== 'nurse') return;
    const enabled = this.paid.includes(String(id));
    this.field.disabled = !enabled;
    this.field.required = enabled;
    this.querySelector('[data-required-mark]').hidden = !enabled;
  }
  disconnectedCallback() { this.controller?.abort(); }
}
if (!customElements.get('bts-personalization')) customElements.define('bts-personalization',BtsPersonalization);